import React from 'react';
import Modal from '../../shared/Modal';
import styles from './styles/styles.module.scss';
import CreateNewList from '../CreateNewList';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function CreateNewListModal({ handleClose, handleListCreated }) {
  return (
    <Modal handleBackgroundClick={handleClose}>
      <div className={styles['create-list-container']}>
        <button className="close" onClick={handleClose} type="button" label={StringConstantsMixin.strings.CLOSE} />
        <div className={styles.title}>{StringConstantsMixin.strings.LIST_MODAL.CREATE_NEW_LIST}</div>
        <CreateNewList edit={true} handleCancelClick={handleClose} handleListCreated={handleListCreated} />
      </div>
    </Modal>
  );
}
